export const CONTAINER_MOVE_STATE = 'ContainerMove';
export const CONTAINER_ASSIGNED_STATE = 'ContainerAssign';
export const CONTAINER_LABEL_CART = 'CRT'
export const CONTAINER_SCAN_LOCATION_STAGE = 'STG'
export const PACKAGE_EVENT_STATE_STOWED = 'STOWED'
export const PACKAGE_EVENT_STATE_INDUCTED = 'INDUCTED'
export const PACKAGE_EVENT_STATE_PICKED = 'PICKED'
export const PACKAGE_EVENT_STATE_STAGED = 'STAGED'
export const PACKAGE_TYPE_OV = "OV"
export const CONTAINER_TYPE_BAG = "BAG"
export const CONTAINER_LABEL = "containerLabel"
export const KG_TO_POUND = 2.20462
export const HEAVY_BAG = 40
export const HEAVY_CART = 450
export const HEAVY_PACKAGE = 20
export const SCAN_LOCATION = "scanLocation"
export const INITIAL_MESSAGE = 'Report generation in progress. This will take around {0} minutes';
export const PACKAGE_DETAIL_PROCESSING = `Hang tight!!! 
 Processing Package Data...
 Total {0} Packages for Induct,
 Total {1} for Stow,
 Total {2} for Pick OV, 
 Total {3} Stage OV`;

export const CONTAINER_DETAIL_PROCESSING = `Package fetch sucessful!!!
 Processing Bags now...
 Total {0} Bags`;
export const CART_DETAIL_PROCESSING = 'Almost Done...Processing Cart Metadata now !!! Total {0} carts';
export const PROCESS_NAME = "IncidentIQ";
export const METRIC_NAME_GNERATE_REPORT = "generateReport";
export const METRIC_NAME_REGNERATE_REPORT = "reGenerateReport"
export const ERROR_MESSAGE_START_TIME_SHOULD_BE_LESS = "Start time should be less than end Time";
const NON_CONVEYABLE_PACKAGE_SIZE = 42
const CM_TO_INCH = 0.3937

const UNIT_CONVERSION_MAP_WEIGHT = {
    kg: 1,          // 1 kg = 1 kg
    g: 0.001,       // 1 g = 0.001 kg
    lb: 0.453592,   // 1 lb = 0.453592 kg
    oz: 0.0283495   // 1 oz = 0.0283495 kg
};

const UNIT_CONVERSION_MAP_LENGTH = {
    cm: 1,
    mm: 0.1,
    m: 100,
    in: 2.54,
    ft: 30.48,
};

export const getDateFromEpoch = (epoch) => {
    const epochDt = new Date(epoch);
    return epochDt.toDateString() + " " + epochDt.toLocaleTimeString();
}
export const calculateReportUpdateEpoch = (startEpoch, startTime, endTime) => {
    const startReportDate = new Date(startEpoch);
    // 
    const startReportYear = startReportDate.getFullYear();
    const startReportMonth = startReportDate.getMonth();
    const startReportDay = startReportDate.getDate();

    const [startHour, startMinute, startSecond] = startTime.split(':');
    const [endHour, endMinute, endSecond] = endTime.split(':');

    let startDateTime = new Date(startReportYear, startReportMonth, startReportDay, startHour, startMinute, startSecond);
    let endDateTime = new Date(startReportYear, startReportMonth, startReportDay, endHour, endMinute, endSecond);

    // Adjust the start and end dates if necessary
    if ((endHour > 17 && endHour <= 24) || (endHour === "17" && endMinute > 0)) {
        endDateTime.setDate(endDateTime.getDate() - 1);
    }

    if (startHour >= 17 && startHour <= 24) {
        startDateTime.setDate(startDateTime.getDate() - 1);
    }

    const newStartEpoch = Math.floor(startDateTime.getTime());
    const newEndEpoch = Math.floor(endDateTime.getTime());

    return {
        newStartEpoch,
        newEndEpoch
    };
};


export const StringUtil = {
    format: function (string, ...args) {
        let formattedString = string;
        for (let i = 0; i < args.length; i++) {
            const regex = new RegExp(`\\{${i}\\}`, 'g');
            formattedString = formattedString.replace(regex, args[i]);
        }
        return formattedString;
    }
};

export const adjustTimeBasedOnResetClock = (actualTime) => {
    return actualTime - (7 * 60 * 60 * 1000)
}

export const getUniqueElementsFromList = (list, property) => {
    return list.filter((obj, index, arr) => {
        return (
            arr.findIndex((filterObj) => filterObj[property] === obj[property]) ===
            index
        );
    })
};

/*
 * Checks if the package is non-conveyable based on package dimensions.
 */
export const isPackageNonConveyable = (packageData) => {
    if (packageData.packageLength.value * CM_TO_INCH > NON_CONVEYABLE_PACKAGE_SIZE ||
        packageData.packageWidth.value * CM_TO_INCH > NON_CONVEYABLE_PACKAGE_SIZE ||
        packageData.packageHeight.value * CM_TO_INCH > NON_CONVEYABLE_PACKAGE_SIZE) {
        return true
    } else {
        return false
    }
}

export const convertWeightToKilograms = (weight, unit) => {
    const lowercaseUnit = unit.toLowerCase();
    if (lowercaseUnit in UNIT_CONVERSION_MAP_WEIGHT) {
        return weight * UNIT_CONVERSION_MAP_WEIGHT[lowercaseUnit];
    } else {
        return 0;
    }
};

export const convertLengthToCm = (length, unit) => {
    const lowercaseUnit = unit.toLowerCase();
    if (lowercaseUnit in UNIT_CONVERSION_MAP_LENGTH) {
        return length * UNIT_CONVERSION_MAP_LENGTH[lowercaseUnit];
    } else {
        return 0;
    }
};

export const epochDiffInDays = (epoch1, epoch2) => {
    const diffInMilliseconds = epoch2 - epoch1;
    const millisecondsInADay = 1000 * 60 * 60 * 24;
    const diffInDays = Math.floor(diffInMilliseconds / millisecondsInADay);
    return diffInDays;
};

export const delay = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
};



// WEBPACK FOOTER //
// ./src/components/detailPages/associateDetails/safetyReport/Util.js